import React, { useState, useEffect } from "react";
import { Reveal, Rich, PortraitSlot } from "./primitives";

/* ———— herbruikbaar: tekst ———— */
export function BlockTekst({ inhoud }) {
  const cream = inhoud.achtergrond === "cream";
  const line = cream ? "var(--line-cream)" : "var(--line)";
  const gold = cream ? "var(--gold-deep)" : "var(--gold)";
  const kolommen = String(inhoud.kolommen || "2") === "2" ? 2 : 1;
  return (
    <section data-testid="block-tekst" className={cream ? "tone-cream" : ""} style={{
      background: cream ? "var(--cream)" : "var(--ink)",
      color: cream ? "var(--cream-ink)" : "var(--cream)",
      padding: "clamp(80px, 10vw, 150px) 0", borderTop: `1px solid ${line}`,
    }}>
      <div className="container">
        <Reveal>
          <div style={{ display: "flex", alignItems: "baseline", gap: 32, marginBottom: 48, flexWrap: "wrap" }}>
            <div className="eyebrow" style={{ color: gold }}>{inhoud.kleine_kop}</div>
            <div style={{ flex: 1, height: 1, background: line, minWidth: 40 }} />
          </div>
          <Rich as="h2" html={inhoud.kop} className="display swof-kop" style={{
            fontSize: "clamp(44px, 7vw, 130px)", lineHeight: 0.94, letterSpacing: "-0.035em",
            margin: "0 0 clamp(32px, 4vw, 56px)", fontWeight: 400,
          }} />
        </Reveal>
        {inhoud.lede && (
          <Reveal>
            <Rich as="p" html={inhoud.lede} style={{
              maxWidth: "30ch", margin: "0 0 clamp(48px, 6vw, 88px)", fontFamily: "var(--serif)",
              fontStyle: "italic", fontSize: "clamp(26px, 2.8vw, 44px)", lineHeight: 1.18,
              letterSpacing: "-0.015em",
            }} />
          </Reveal>
        )}
        <Reveal>
          <Rich html={inhoud.body} className="swof-body swof-body-2col" style={{
            columnCount: kolommen, columnGap: "clamp(40px, 5vw, 80px)", fontFamily: "var(--serif)",
            fontSize: "clamp(18px, 1.45vw, 22px)", lineHeight: 1.6, textWrap: "pretty",
            color: cream ? "rgba(26,22,17,0.8)" : "rgba(243,234,215,0.8)",
          }} />
        </Reveal>
      </div>
    </section>
  );
}

/* ———— herbruikbaar: fotoblok ———— */
export function BlockFotoblok({ inhoud, mediaById }) {
  const [zoom, setZoom] = useState(null);
  const ids = inhoud.foto_ids || [];
  const perRij = Number(inhoud.per_rij) || 5;
  const verhouding = inhoud.verhouding || "3 / 2";
  const tegels = ids.length ? ids : Array.from({ length: perRij }, () => null);

  useEffect(() => {
    if (zoom === null) return;
    const onKey = (e) => { if (e.key === "Escape") setZoom(null); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [zoom]);

  return (
    <section data-testid="block-fotoblok" style={{
      background: "#050403", color: "var(--cream)",
      padding: "clamp(72px, 9vw, 130px) 0", borderTop: "1px solid var(--line)",
    }}>
      <div className="container">
        <Reveal>
          <div style={{ marginBottom: "clamp(32px, 4vw, 56px)" }}>
            <div className="eyebrow" style={{ color: "var(--gold)", marginBottom: 16 }}>{inhoud.kleine_kop}</div>
            <Rich as="h2" html={inhoud.kop} className="swof-kop" style={{
              fontFamily: "var(--serif)", fontSize: "clamp(34px, 4.6vw, 76px)",
              margin: 0, fontWeight: 400, lineHeight: 1, letterSpacing: "-0.02em",
            }} />
          </div>
        </Reveal>
        <Reveal stagger>
          <div className="galerij-grid" style={{
            display: "grid", gridTemplateColumns: `repeat(${perRij}, minmax(0, 1fr))`, gap: 6,
          }}>
            {tegels.map((id, i) => (
              <button key={i} onClick={() => setZoom(i)} aria-label={`Foto ${i + 1}`} style={{
                padding: 0, border: "none", background: "transparent", cursor: "pointer", display: "block",
              }}>
                <PortraitSlot monogram={String(i + 1)} ratio={verhouding} label={`foto ${i + 1}`}
                  src={id ? mediaById[id]?.url : null} alt={id ? mediaById[id]?.alt : null} />
              </button>
            ))}
          </div>
        </Reveal>
      </div>
      {zoom !== null && (
        <div onClick={() => setZoom(null)} style={{
          position: "fixed", inset: 0, zIndex: 400, background: "rgba(5,4,3,0.94)",
          backdropFilter: "blur(6px)", display: "flex", alignItems: "center",
          justifyContent: "center", padding: "clamp(24px, 5vw, 80px)", cursor: "zoom-out",
        }}>
          <div style={{ width: "min(1100px, 100%)" }}>
            <PortraitSlot monogram={String(zoom + 1)} ratio={verhouding}
              label={`foto ${zoom + 1} — volgt`}
              src={tegels[zoom] ? mediaById[tegels[zoom]]?.url : null} />
            <div style={{
              marginTop: 14, display: "flex", justifyContent: "space-between",
              fontFamily: "var(--mono)", fontSize: 10, letterSpacing: "0.2em",
              textTransform: "uppercase", color: "rgba(243,234,215,0.55)",
            }}>
              <span>{`${zoom + 1} / ${tegels.length}`}</span>
              <span>Esc om te sluiten</span>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
